










import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';
import { PaymentBasics } from '@/models/common/payment-basics';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbIcon
    }
})
export default class EditPaymentBasics extends Vue {
    @Prop(PaymentBasics) private paymentBasics!: boolean;
}
